module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "vehicles"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Contrato " + _vm._s(_vm.contractId) + "\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Veículos\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-cell"
  }, [_c('i', {
    staticClass: "icon-search-input"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plateOrObuid),
      expression: "plateOrObuid"
    }],
    staticClass: "form-control input-search",
    attrs: {
      "type": "search",
      "name": "",
      "value": "",
      "placeholder": "Digite a placa"
    },
    domProps: {
      "value": (_vm.plateOrObuid)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plateOrObuid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-search",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("Buscar")])])]), _vm._v(" "), _c('br'), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [(_vm.contractActive) ? _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'contract-vehicles-new',
        params: {
          contractId: _vm.contractId
        }
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-add-vehicle align-icon-left-white"
  }), _vm._v("\n            Adicionar veículos\n          ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showMessageContract
    }
  }, [_c('i', {
    staticClass: "icon-add-vehicle align-icon-left-white"
  }), _vm._v("\n            Adicionar veículos\n          ")])], 1)]), _vm._v(" "), (_vm.state == 'LOADING') ? _c('div', {
    staticClass: "margin-t20"
  }, [_vm._v("\n        Carregando veículos. Aguarde...\n      ")]) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-warning margin-t20"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.itens && _vm.data.itens.length > 0) ? _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "margin-t20"
  }, [_c('div', {
    staticClass: "search point-line"
  }, [(_vm.contractActive) ? _c('router-link', {
    staticClass: "label-link pull-right",
    attrs: {
      "to": {
        name: 'vehicles-p-to-p',
        params: {
          contractId: _vm.contractId
        }
      }
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n            Cadastrar veículos no sistema Ponto a Ponto\n          ")]) : _c('a', {
    staticClass: "label-link pull-right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showMessageContract
    }
  }, [_vm._v("\n            Cadastrar veículos no sistema Ponto a Ponto\n          ")])], 1), _vm._v(" "), _vm._l((_vm.data.itens), function(vehicle, index) {
    return _c('div', {
      key: index,
      staticClass: "content-box vehicles margin-10"
    }, [_c('div', {
      staticClass: "newContainerStatusBox"
    }, [_c('div', {
      staticClass: "containerVehicleBox"
    }, [_c('div', {
      staticClass: "inline plate-box"
    }, [_c('p', {
      staticClass: "cell-plate info-car"
    }, [_c('span', [_vm._v(_vm._s(vehicle.plate))])])]), _vm._v(" "), _c('div', {
      staticClass: "inline tag-box"
    }, [_c('p', {
      staticClass: "no-margin bold"
    }, [_vm._v("TAG N°")]), _vm._v(" "), _c('p', {
      staticClass: "no-margin"
    }, [_vm._v(_vm._s(vehicle.tagSerialNumber || 'Não possui'))])]), _vm._v(" "), (/^\d$/.test(vehicle.plate.charAt(5))) ? _c('div', {
      staticClass: "inline"
    }, [_c('button', {
      staticClass: "merc-button",
      attrs: {
        "alt": "ícone"
      },
      on: {
        "click": function($event) {
          return _vm.showSwitchPlate(vehicle.plate)
        }
      }
    }, [_vm._v("Mudar para padrão Mercosul\n              "), _c('img', {
      staticClass: "merc-icon",
      attrs: {
        "src": require("../../assets/img/icons/merc-arrow.svg")
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "inline vehicle-box"
    }, [_c('p', {
      staticClass: "no-margin bold"
    }, [_vm._v(_vm._s(vehicle.brandName))]), _vm._v(" "), _c('p', {
      staticClass: "no-margin bold"
    }, [_vm._v(_vm._s(_vm._f("firstWord")(vehicle.modelName)))]), _vm._v(" "), _c('p', {
      staticClass: "no-margin three-dots"
    }, [_vm._v(_vm._s(_vm._f("fromSecWord")(vehicle.modelName)))])]), _vm._v(" "), _c('div', {
      staticClass: "inline status-box"
    }, [_c('p', {
      staticClass: "no-margin"
    }, [_c('span', {
      class: _vm.getStatusClass(vehicle)
    }), _vm._v("\n              " + _vm._s(_vm.getStatus(vehicle)) + "\n            ")]), _vm._v(" "), _c('p', {
      staticClass: "no-margin date-box"
    }, [_c('i', {
      staticClass: "icon-clock"
    }), _vm._v(" " + _vm._s(_vm._f("dateTime")(vehicle.installDate || '00/00/0000 00:00')) + "\n              "), _c('i', {
      staticClass: "icon-info",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "top",
        "title": "Data da situação atual da TAG"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "no-margin"
    }, [_c('i', {
      staticClass: "icon-axis"
    }), _vm._v(" " + _vm._s(vehicle.catergoryAxesName))])]), _vm._v(" "), (_vm.isGrouper === true) ? _c('div', {
      staticClass: "dropdown"
    }, [_c('div', {
      staticClass: "dropdown-select"
    }, [_c('span', {
      staticClass: "select"
    }, [_vm._v(_vm._s(vehicle.nomeAgrupador ? vehicle.nomeAgrupador : "Selecione um Agrupador"))]), _vm._v(" "), _c('img', {
      attrs: {
        "width": "12px",
        "src": require("../../assets/img/icons/arrow-up.svg")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-list"
    }, _vm._l((_vm.groupersOp), function(option) {
      return _c('div', {
        key: option.value,
        staticClass: "dropdown-list-item",
        attrs: {
          "value": option.value
        }
      }, [_c('p', {
        on: {
          "click": function($event) {
            return _vm.handleOptionChange(vehicle, option.value)
          }
        }
      }, [_vm._v(_vm._s(option.caption))])])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "btn-group"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'vehicle-movement',
          params: {
            contractId: _vm.contractId,
            vehicleId: vehicle.vehicleId
          }
        },
        "tag": "a",
        "data-toggle": "tooltip",
        "title": "Movimentações do veículo"
      }
    }, [_c('div', {
      staticClass: "btn btn-icon"
    }, [_c('i', {
      staticClass: "icon-place bold"
    })])]), _vm._v(" "), (!_vm.showUnblock(vehicle)) ? _c('a', {
      class: {
        'link-disabled': !_vm.showBlock(vehicle)
      },
      attrs: {
        "data-toggle": "tooltip",
        "title": "Bloquear veículo temporariamente"
      },
      on: {
        "click": function($event) {
          _vm.vehicleToBlock = vehicle
        }
      }
    }, [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (_vm.showUnblock(vehicle)) ? _c('a', {
      class: {
        'link-disabled': !_vm.showUnblock(vehicle)
      },
      attrs: {
        "data-toggle": "tooltip",
        "title": "Desbloquear veículo"
      },
      on: {
        "click": function($event) {
          return _vm.unblockTag(vehicle)
        }
      }
    }, [_vm._m(1, true)]) : _vm._e(), _vm._v(" "), _c('router-link', {
      class: {
        'link-disabled': !_vm.showReplace(vehicle)
      },
      attrs: {
        "tag": "a",
        "to": {
          name: 'replace-tag',
          params: {
            contractId: _vm.contractId,
            vehicleId: vehicle.vehicleId
          }
        },
        "data-toggle": "tooltip",
        "title": "Substituir TAG"
      }
    }, [_c('div', {
      staticClass: "btn btn-icon"
    }, [_c('i', {
      staticClass: "icon-sync bold"
    })])])], 1)])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('pagination', {
    attrs: {
      "model": _vm.page
    },
    on: {
      "page-change": _vm.setCurrentPage
    }
  })], 1)]), _vm._v(" "), (_vm.data && _vm.data.itens) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 result-table-count text-center"
  }, [_vm._v("\n          Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n          encontrados.\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.exportError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.exportError) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.hasVehicles) ? _c('button', {
    staticClass: "btn btn-default margin-10 pull-right",
    attrs: {
      "type": "button",
      "disabled": _vm.exportingVehicles
    },
    on: {
      "click": _vm.exportVehicles
    }
  }, [_vm._v("\n            " + _vm._s(_vm.exportingVehicles ? 'Exportando...' : 'Exportar Veículos') + "\n          ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-back margin-10",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n            Voltar\n          ")])], 1)])])]), _vm._v(" "), (_vm.vehicleToBlock) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block",
      "background": "rgba(230, 230, 230, 0.8)"
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header modal-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.vehicleToBlock = undefined
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bloqueio Temporário da TAG")])]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage),
      expression: "errorMessage"
    }],
    staticClass: "alert alert-danger margin-b20"
  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('reasonBlock')
    }
  }, [_vm._m(2), _vm._v(" "), _c('label', {
    staticClass: "bold-600"
  }, [_vm._v("Motivo do bloqueio:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.reasonBlock),
      expression: "reasonBlock"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "name": "reasonBlock",
      "cols": "35",
      "rows": "3",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.reasonBlock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reasonBlock = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('reasonBlock')))]), _vm._v(" "), _c('label', [_vm._v("Caracteres restantes " + _vm._s((200 - _vm.reasonBlock.length)) + ".")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.blockTag()
      }
    }
  }, [_vm._v("Bloquear")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showMercModal) ? _c('div', [_c('modal-switch-plate', {
    attrs: {
      "plateToConvert": _vm.plateToConvert
    },
    on: {
      "fechar": function($event) {
        return _vm.fecharModal()
      },
      "success": _vm.showSuccessModal,
      "error": _vm.showErrorModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay-new"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showSuccessConvertModal) ? _c('div', {
    staticClass: "modalSucessMerc"
  }, [_c('modal-sucess-merc', {
    on: {
      "fechar": function($event) {
        return _vm.concluirSucesso()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay-new"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showModalErrorConvert) ? _c('div', {
    staticClass: "modalErrorMerc"
  }, [_c('modal-error-merc', {
    on: {
      "fechar": function($event) {
        return _vm.concluirErro()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay-new"
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-icon"
  }, [_c('i', {
    staticClass: "icon-not-allowed bold"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-icon"
  }, [_c('i', {
    staticClass: "icon-unlock bold"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("É recomendado em situações onde deseja-se bloquear o veículo temporariamente, ex: ao enviar o veículo para oficina, sendo possível seu desbloqueio.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v("Pode levar até 6 horas para que aconteça o bloqueio em todas as praças de pedágios.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "icon-warning"
  }), _vm._v(" Não isenta o pagamento de mensalidade.\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "icon-warning"
  }), _vm._v(" Caso não possua mais o veículo, entre em contato com a central de atendimento e solicite o cancelamento da TAG.")]), _vm._v(" "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-ba986cdc!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/vehicles.vue
// module id = 2209
// module chunks = 1